import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#0d0d1a] border-t border-white/[0.06]">
      <div className="max-w-7xl mx-auto px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-3">
              <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-gradient-to-br from-rose-500 to-orange-500 text-white font-bold text-sm">
                S
              </div>
              <span className="text-white font-semibold text-sm">Signal SMS</span>
            </div>
            <p className="text-gray-600 text-sm leading-relaxed max-w-xs">
              누구나 쉽게 사용할 수 있는<br />스마트 문자 발송 플랫폼
            </p>
          </div>

          {/* Service */}
          <div>
            <h4 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">서비스</h4>
            <ul className="space-y-2">
              {[
                { label: "대량 문자 발송", href: "/dashboard/send" },
                { label: "예약 발송", href: "/dashboard/schedule" },
                { label: "발송 내역", href: "/dashboard/history" },
                { label: "주소록 관리", href: "/dashboard/contacts" },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.href}
                    className="text-gray-600 hover:text-gray-300 text-sm transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">지원</h4>
            <ul className="space-y-2">
              {[
                { label: "고객 지원", href: "/dashboard/support" },
                { label: "API 문서", href: "/dashboard/settings" },
                { label: "요금 안내", href: "/#pricing" },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.href}
                    className="text-gray-600 hover:text-gray-300 text-sm transition-colors cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">연락처</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-gray-600 text-sm">
                <i className="ri-mail-line text-gray-500"></i>
                support@signalsms.com
              </li>
              <li>
                <a
                  href="https://t.me/signal_sms"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-gray-600 hover:text-[#24A1DE] text-sm transition-colors cursor-pointer"
                >
                  <i className="ri-telegram-line text-gray-500"></i>
                  텔레그램 @signal_sms
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-600 text-sm">
                <i className="ri-time-line text-gray-500"></i>
                평일 09:00 ~ 18:00
              </li>
            </ul>
          </div>
        </div>

        <div className="h-px bg-white/[0.06] mb-6"></div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-700 text-xs">
            © {new Date().getFullYear()} Signal SMS. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-gray-700 text-xs cursor-pointer hover:text-gray-500 transition-colors">이용약관</span>
            <span className="text-gray-700 text-xs cursor-pointer hover:text-gray-500 transition-colors">개인정보처리방침</span>
          </div>
        </div>
      </div>
    </footer>
  );
}